module.exports =
  IMAGE_TYPES: ['jpg', 'jpeg', 'png', 'gif', 'bmp']
  DOC_TYPES: ['pdf', 'ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx']